import { apiErrorDetails } from '../../utils/apiError';

export type BattleJoinFailure =
  | { kind: 'tradeLink' }
  | { kind: 'message'; key: 'errMultiacc' }
  | { kind: 'generic' };

const JOIN_RULES: Record<string, BattleJoinFailure> = {
  CASE_BATTLE_TRADE_LINK_REQUIRED: { kind: 'tradeLink' },
  MULTIACC_PARTICIPATION_NOT_ALLOWED: { kind: 'message', key: 'errMultiacc' },
};

export function resolveJoinFailure(err: unknown): BattleJoinFailure {
  const rule = apiErrorDetails(err)?.rule;
  if (typeof rule === 'string' && JOIN_RULES[rule]) return JOIN_RULES[rule];
  return { kind: 'generic' };
}
